import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Box, TextField } from "@mui/material";
import { useAppDispatch } from "../../../store";
import { setCurrentPage } from "../../../store/auth/authReducer";
import { useSelector } from "react-redux";
import { logOut } from "../../../utils/logOut";
import pako from 'pako';
import { Base64 } from 'js-base64';
import { prepareArrowJSON } from "../../../utils/prepareJSON";
import TranslatedText from "../../../utils/Translate";
import { useSnackbar } from "../../../utils/SnackbarContext";

export default function ConversationDetail() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type');
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [detailData, setDetailData] = useState<any>({});
    const accesslevel = useSelector((state: any) => state.auth.authData.accesslevel);

    const { showSnackbar } = useSnackbar();

    useEffect(() => {
        type === 'edit' && fetchData();
    }, []);

    async function fetchData(params: object = {}) {
        setLoading(true);
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/transcript/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
                params: params
            });

            // Декодирование Gzip строки
            const base64data = response.data[0].fields;
            const binaryString = Base64.atob(base64data);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            const decodedDescription = pako.inflate(bytes, { to: 'string' });

            setDetailData({
                ...response.data[0],
                fields: prepareArrowJSON(decodedDescription)
            });

            setLoading(false);
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch);
            } else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false);
        }
    }

    useEffect(() => {
        dispatch(setCurrentPage('All fields'));
    }, [dispatch]);

    return (
        <>
            <Box sx={{ width: "100%", display: "flex", flexDirection: 'column', alignItems: "center" }}>
                <TextField sx={{ width: 450, mb: 2 }} value={detailData.when || ''} variant="outlined" size="small" label={<TranslatedText text={'Command time'} />} />
                <TextField sx={{ width: 450, '& textarea': { resize: 'vertical' }, mb: 2 }}
                    value={detailData.fields || ''}
                    rows={5}
                    multiline
                    label={<TranslatedText text={"Field details"} />}
                    fullWidth
                    variant="outlined" />
                <TextField sx={{ width: 450, '& textarea': { resize: 'vertical' }, mb: 2 }}
                    value={detailData.evalerror || ''}
                    rows={5}
                    multiline
                    label={<TranslatedText text={"Message"} />}
                    fullWidth
                    variant="outlined" />
                <TextField sx={{ width: 450, '& textarea': { resize: 'vertical' }, mb: 2 }}
                    value={detailData.lastinputvalue || ''}
                    rows={5}
                    multiline
                    label={<TranslatedText text={"Accepted input"} />}
                    fullWidth
                    variant="outlined" />
                <TextField sx={{ width: 450, '& textarea': { resize: 'vertical' }, mb: 2 }}
                    value={detailData.conversationhistoryfields || ''}
                    rows={5}
                    multiline
                    label={<TranslatedText text={"Fields set by the command"} />}
                    fullWidth
                    variant="outlined" />
                <TextField sx={{ width: 450, '& textarea': { resize: 'vertical' }, mb: 2 }}
                    value={detailData.transcript || ''}
                    rows={5}
                    multiline
                    label={<TranslatedText text={"Transcript"} />}
                    fullWidth
                    variant="outlined" />
            </Box>
        </>
    );
}
